import TermDrawer from "../TermDrawer";
import "./TopicsDrawer.scss";

const EditTopicsDrawer = () => <TermDrawer type="edit-topic" />;

export default EditTopicsDrawer;
